/* unplugin-vue-components disabled */import script from "./initiator_guide.vue?vue&type=script&setup=true&lang=js"
export * from "./initiator_guide.vue?vue&type=script&setup=true&lang=js"

import "./initiator_guide.vue?vue&type=style&index=0&id=1722df56&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1722df56"]])

export default __exports__